import { Modal, ModalProps, withModalConditionalRender } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { VatExemptionMentionInfoModalBody } from './elements/VatExemptionMentionInfoModalBody'
import { VatExemptionMentionInfoModalFooter } from './elements/VatExemptionMentionInfoModalFooter'

const VatExemptionMentionInfoModalComponent = ({ ...modalProps }: ModalProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Modal {...modalProps} size="s">
      <Modal.Header title={t('external_invoices.editor.summary.vat_exemption_mention_info.modal.title')} />
      <VatExemptionMentionInfoModalBody />
      <VatExemptionMentionInfoModalFooter id={modalProps.id} />
    </Modal>
  )
}

export const VatExemptionMentionInfoModal = withModalConditionalRender(VatExemptionMentionInfoModalComponent)
